import { createApi } from '@reduxjs/toolkit/query/react';
import apiBaseQuery from './axiosBaseQuery'
export const CLIMATE_RISK_API_REDUCER_KEY = 'climateRiskApi';


export const climateRiskApi = createApi({
    reducerPath: CLIMATE_RISK_API_REDUCER_KEY,
    baseQuery: apiBaseQuery,
    tagTypes: ['climateRisks'],
    endpoints: (builder) => ({
        getAllClimateRisk: builder.query({
            query: ({ page, q, climate_scenario, limit }) => ({
                url: `admin/repository/climate-risk-factors?page=${page}&q=${q}&climate_scenario=${climate_scenario}&limit=${limit}`
            }),
            providesTags: ['climateRisks']
        }),
        getClimateRisk: builder.query({
            query: (id) => ({
                url: `admin/repository/climate-risk-factors/${id}`
            }),
            providesTags: ['climateRisks']
        }),
        createClimateRisk: builder.mutation({
            query: (body) => ({
                url: `admin/repository/climate-risk-factors`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['climateRisks']
        }),
        updateClimateRisk: builder.mutation({
            query: ({ id, ...rest }) => ({
                url: `admin/repository/climate-risk-factors/${id}`,
                method: 'PUT',
                body: rest
            }),
            invalidatesTags: ['climateRisks']
        }),
    })
});

export const {
    useGetAllClimateRiskQuery,
    useGetClimateRiskQuery,
    useCreateClimateRiskMutation,
    useUpdateClimateRiskMutation,
} = climateRiskApi;